import SessionExpiryIcon from './SessionExpiryIcon';

export default SessionExpiryIcon;
